/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { Alert } from "@material-ui/lab";
import "react-reflex/styles.css";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";

import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import TkFailedLot from "../screens/TkFailedLot";

function TkPopCompleteProcessDialog  ( props ) {

    const { t } = useTranslation ();
    const [instance, setInstance] = useState ();
    const [formData, setFormData] = useState({});
    const [schema, setSchema] = useState();

    const [failedLotList, setFailedLotList] = useState ([]);

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const {

        id,
        lotInfo,

        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        customizeErrorMsgCallback,
        modifyUrlCallback,

        ...others

    } = props;

    const notifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    useEffect ( () => {

        let schema = {

            name: "TkPopProductManage",
            type: "BASE TABLE",
            searchAll: false,

            columns: [

                {

                    name: "workOrderNumber",
                    type: "varchar(45)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "modelName",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "modelPartName",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "partNo",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "partSeq",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    formGroup: 0,
                    formOrder: 10,
                    formItemType: "text",

                },
                {

                    name: "plannedQty",
                    type: "float",
                    nullable: "NO",
                    key: "",
                    readonly: true,
                    default: null,
                    formOrder: 10,
                    formItemType: "text",
                    validation: {
                        msg: "error.floatRequired",
                        type: "regexp",
                        value: "^[+-]?([0-9]*[.])?[0-9]+$"
                    },

                },
                {

                    name: "resultQty",
                    type: "float",
                    nullable: "NO",
                    readonly: true,
                    default: null,
                    formOrder: 20,
                    formItemType: "float",

                },
                
            ]

        };

        setSchema ( schema );

    }, [] );

    useEffect ( () => {

        if ( lotInfo ) {

            setFormData ( ( formData ) => {

                let newFormData = {

                    ...formData,

                    lotNo: lotInfo.lotNo,
                    machineCode: lotInfo.machineCode,
                    parentPlanId: lotInfo.parentPlanId,

                    workOrderNumber: lotInfo.workOrderNumber,
                    modelName: lotInfo.modelName,
                    modelPartName: lotInfo.modelPartName,
                    partNo: lotInfo.partNo,
                    partSeq: lotInfo.partSeq,
                    
                    plannedQty : lotInfo.plannedQty,
                    resultQty : lotInfo.qtyCurrent,
                    failQty: 0,

                    opCode: lotInfo.opCode,

                };

                return newFormData;

            } );

        } 

    }, [lotInfo])

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        if ( onSuccess ) {

            onSuccess ( result.data );

        }

        instance.hide();

    };

    const onApiFailure = (lotInfo, reason) => {

        if ( customizeErrorMsgCallback ) { 

            notifyFailure ( customizeErrorMsgCallback ( reason ) );

        } else {

            notifyFailure ( t ( "error.productionStartFail", { lotNo: lotInfo.lotNo } ) + ` : ${ reason.response ? reason.response.data : JSON.stringify ( reason ) }` );

        }

    };

    const checkItemValidataion = ( schema, formData ) => {

        for ( const column of schema.columns ) {

            let [valid, msg] = checkValidation ( "create", column, column.validation, formData[column.name] || "" );

            if ( !valid ) {

                notifyWarning ( msg );
                return false;

            }

        }

        if ( formData.qty <= 0 ) {

            notifyWarning ( t ( "error.emptyOrNegativeProductionQty") );
            return false;

        }

        return true;

    };

    const onOk = ( schema, lotInfo, failedLotList, formData ) => {

        if ( ! checkItemValidataion ( schema, formData ) ) {

            console.error ( "Form Validation Failed" );
            return;

        }

        if ( schema.validation ) {

            let [valid, msg] = checkConditionWithMsg (

                formData,
                schema.validation

            );

            if (!valid) {

                notifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;

            }

        }

        let url = `/api/${schema.name}/${lotInfo.planId}/end`;

        if (modifyUrlCallback) {

            url = modifyUrlCallback(url);

        }

        let apiData = {
            ...formData,
            failedLotList: failedLotList
        };

        // build base api url
        let form = new FormData ();

        let json = {};
        let deleted = {};

        for ( const formItem in apiData ) {

            json[formItem] = apiData[formItem];

        }

        form.append ( "deleted", JSON.stringify ( deleted ) );
        form.append ( "json", JSON.stringify ( json ) );
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then ( ( result ) => {
                onApiSuccess ( result );
            } )
            .catch ( ( reason ) => {
                onApiFailure ( lotInfo, reason );
            } );

    }

    const onCancel = () => {

        setFailedLotList([]);

        instance.hide ();

    };

    const onCloseNotification = () => {

        setNotification ( ( notification ) => {

            return ( {...notification, open: false} );

        } );

    };

    const onCloseDialog = () => {

        setFormData ( ( formData ) => {

            let newFormData = {
                ...formData,
                resultQty : formData.plannedQty,

            }

            return newFormData;

        } );

        setFailedLotList([]);

        if ( onClose ) {

            onClose ();

        }

    };

    const onChange = ( formData ) => {

        setTimeout(() => {

            setFormData(formData);

        }, 0);

    };

    const onChangeFailedLotList = ( failedLotList, lotInfo ) => {

        setFailedLotList ( failedLotList );

        let totalFailQty = 0;

        for ( let row of failedLotList ) {

            totalFailQty += row.qty;

        }

        setFormData ( ( formData ) => {

            let newFormData = {

                ...formData,
                resultQty: lotInfo.qtyCurrent - totalFailQty,
                failQty: totalFailQty,

            };

            return newFormData;

        } );

    };

    return (

        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth={maxWidth ? maxWidth : uiConf.autoFormDialogMaxWidth}
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >

            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.Produce.completeProcess" ) }
                </DialogTitle>
            </DialogHeaderWithClose>

            <Divider />

            <DialogContent style={{padding: "0px", height: "600px"}}>

                <ReflexContainer orientation="horizontal">

                    <ReflexElement flex={0.5}>

                        <div
                            style={{
                                padding: "16px"
                            }}                    
                        >

                            <AutoForm
                                id="bop-out-material-warehouse-form"
                                schema={schema}
                                mode="edit"
                                initialData={formData}
                                onChange={onChange}
                            />
                        </div>

                    </ReflexElement>

                    <ReflexSplitter style={{border: "none",height: "1px",color:"lightgray"}} />

                    <ReflexElement flex={0.5} >

                        <TkFailedLot 
                            notifyWarning={notifyWarning} 
                            onChangeFailedLotList={(failedLotList) => onChangeFailedLotList(failedLotList, lotInfo)} 
                            productionQty={lotInfo?.qtyCurrent}
                        />

                    </ReflexElement>

                </ReflexContainer>

                <Snackbar
                    open={notification.open && notification.severity !== "success"}
                    autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                    onClose={onCloseNotification}
                >
                    <Alert
                        onClose={onCloseNotification}
                        variant="filled"
                        severity={notification.severity}
                    >

                        {notification.msg}

                    </Alert>

                </Snackbar>

            </DialogContent>

            <Divider />

            <DialogActionsOkCancel
                labels={[ t("common.ok")]}
                onOk={() => onOk(schema, lotInfo, failedLotList, formData)}
                onCancel={onCancel}
            />

        </Dialog>

    );

}

export default TkPopCompleteProcessDialog ;